









































import { Component, Prop, Vue } from 'vue-property-decorator';
import { IProgram } from '../Scripts/ISearchService';
import { sort } from '../Scripts/Sort';

@Component({
	components: {

	}
})
export default class FavoritesManage extends Vue {
	@Prop() public favorites!: IProgram[];
	@Prop() public value!: IProgram[];

	get ordered (): IProgram[] {
		return sort(this.favorites, (f) => f.title, (f) => f.institutionName);
	}

	get hasFavs (): boolean {
		return this.favorites && this.favorites.length > 0;
	}

	get model (): IProgram[] {
		return this.value;
	}

	set model (value: IProgram[]) {
		this.$emit('input', value);
	}

	get showWarning (): boolean {
		return !this.$store.state.dismissedFavWarning;
	}

	public remove (program: IProgram): void {
		const index = this.model.findIndex((x: IProgram) => x.id === program.id);
		if (index > -1) {
			this.model = this.model.splice(index, 1);
		}

		this.$store.commit('removeFavorite', program);
	}

	public dismiss (): void {
		this.$store.commit('dismissFavWarning');
	}
}
